import { Fragment } from 'react';
import { useEffect } from 'react';
import TabItem from './TabItem';
import type { ITabData } from './tabType';

const GeneralTab = ({ data, className }: { data: ITabData[]; className?: string }) => {
  useEffect(() => {
    // unmount
    return () => {
      console.log('generalTab unmount!!');
    };
  }, []);

  if (!Array.isArray(data) || data?.length === 0) {
    return <Fragment />;
  }

  return (
    <nav className={`tab general-tab ${className || ''}`}>
      <ul className={`col-${data?.length}`}>
        {data?.map((v, i) => (
          <li key={v?.key || i}>
            <TabItem data={v} />
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default GeneralTab;
